import { ApexOptions } from "ng-apexcharts";
import {
  createAxisChartDefaults,
  createBarPlotOptions,
} from "../../shared/charts/chart-defaults";
import { CHART_COLORS, CHART_STYLE } from "../../shared/charts/chart-tokens";
import { CourtOccupancyRow } from "./court-occupancy.types";

function formatHours(minutes: number): string {
  const hours = minutes / 60;
  return `${hours.toLocaleString("en-US", { maximumFractionDigits: 1 })}h`;
}

export function courtOccupancyChartHeight(rowCount: number): number {
  return Math.max(300, rowCount * 48 + 80);
}

export function buildCourtOccupancyChart(
  rows: CourtOccupancyRow[],
): ApexOptions {
  const defaults = createAxisChartDefaults(
    "bar",
    courtOccupancyChartHeight(rows.length),
  );
  return {
    ...defaults,
    colors: [CHART_COLORS.primary],
    dataLabels: {
      enabled: true,
      formatter: (value: number) => `${value.toFixed(1)}%`,
      offsetX: 8,
      style: { colors: [CHART_STYLE.valueLabelColor], fontWeight: 600 },
    },
    grid: {
      borderColor: CHART_STYLE.gridColor,
      padding: { right: 32 },
      xaxis: { lines: { show: true } },
      yaxis: { lines: { show: false } },
    },
    plotOptions: { bar: createBarPlotOptions(true) },
    series: [
      {
        name: "Occupancy",
        data: rows.map((row) => row.occupancyPercent ?? 0),
      },
    ],
    tooltip: {
      ...defaults.tooltip,
      y: {
        formatter: (value: number, context?: { dataPointIndex?: number }) => {
          const row = rows[context?.dataPointIndex ?? -1];
          if (!row || row.occupancyPercent == null) {
            return "No scheduled bookable hours";
          }
          return `${value.toFixed(1)}% · ${formatHours(row.occupiedMinutes)} booked of ${formatHours(row.bookableMinutes)}`;
        },
        title: { formatter: () => "" },
      },
    },
    xaxis: {
      categories: rows.map((row) => `${row.courtName} · ${row.venueName}`),
      labels: {
        formatter: (value: string) => `${value}%`,
        style: { colors: CHART_STYLE.textColor },
      },
      max: 100,
      min: 0,
      tickAmount: 4,
      title: {
        text: "Occupancy",
        style: { color: CHART_STYLE.textColor, fontWeight: 500 },
      },
    },
    yaxis: {
      labels: {
        maxWidth: 210,
        style: { colors: CHART_STYLE.textColor },
      },
    },
  };
}
